import dayjs, { Dayjs } from "dayjs";
import {
  LocalizationProvider,
  PickerChangeHandlerContext,
} from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { StaticDateRangePicker } from "@mui/x-date-pickers-pro/StaticDateRangePicker";
import { PickersShortcutsItem } from "@mui/x-date-pickers/PickersShortcuts";
import {
  DateRange,
  DateRangeValidationError,
} from "@mui/x-date-pickers-pro/models";

const shortcutsItems: PickersShortcutsItem<DateRange<Dayjs>>[] = [
  {
    label: "Last 24 Hours",
    getValue: () => {
      const now = dayjs();
      return [now.subtract(24, "hour"), now];
    },
  },
  {
    label: "Last Week",
    getValue: () => {
      const today = dayjs();
      const prevWeek = today.subtract(7, "day");
      return [prevWeek.startOf("week"), prevWeek.endOf("week")];
    },
  },
  {
    label: "Last 7 Days",
    getValue: () => {
      const today = dayjs();
      return [today.subtract(7, "day"), today];
    },
  },
  {
    label: "Last 14 Days",
    getValue: () => {
      const today = dayjs();
      return [today.subtract(14, "day"), today];
    },
  },
  {
    label: "Last 30 Days",
    getValue: () => {
      const today = dayjs();
      return [today.subtract(30, "day"), today];
    },
  },
  {
    label: "Current Month",
    getValue: () => {
      const today = dayjs();
      return [today.startOf("month"), today.endOf("month")];
    },
  },
  {
    label: "Last 90 Days",
    getValue: () => {
      const today = dayjs();
      return [today.subtract(90, "day"), today];
    },
  },
  { label: "Reset", getValue: () => [null, null] },
];

interface DateRangePickerProps {
  onChange: (
    value: DateRange<Dayjs>,
    context: PickerChangeHandlerContext<DateRangeValidationError>
  ) => void;
}

export const DateRangePicker = (props: DateRangePickerProps) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <StaticDateRangePicker
        slotProps={{
          shortcuts: {
            items: shortcutsItems,
          },
          actionBar: { actions: [] },
        }}
        calendars={2}
        onChange={props.onChange}
      />
    </LocalizationProvider>
  );
};
